import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent } from "util";

const states = [
  {
    name: "app.management.product-sales-report",
    url: "/vendas-por-produto",
    views: {
      "content@app": ConnectComponent(View, Presenter)
    },
    data: {
      navigation: {
        name: "Vendas por Produto",
        priority: 400,
        // authorization: (context => context.user.permissions.includes('view_closed_sales')),
        state: "app.management.product-sales-report"
      }
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/management/product-sales-report/index.js